var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dynamic-object-form-structure", {
    attrs: {
      "object-uuid": _vm.objectUUID,
      "object-layer": _vm.objectLayer,
      "loading-structure": _vm.loadingStructure,
      "loading-save": _vm.loadingSave,
      "permission-name": _vm.form.permission,
      "object-type-translation-key": _vm.form.name_translation,
      tabs: _vm.visibleTabs,
      "active-tab": _vm.activeTab,
      "action-type": _vm.actionType,
      saveIsDisabled: !_vm.required.filled,
      "map-element": _vm.$parent.$refs.formsContainer,
      "previous-pos-x": _vm.previousPosX,
      "previous-pos-y": _vm.previousPosY,
      "data-was-changed": _vm.dataWasChanged,
      "fields-still-need-filled": _vm.required.stillNeedFilled,
      "object-data": _vm.objectData
    },
    on: {
      updateActiveTab: function($event) {
        _vm.activeTab = $event
      },
      changeViewMode: _vm.changeViewModeOfObject,
      openDetails: _vm.openDetails,
      refresh: _vm.refresh,
      clearData: _vm.clearData,
      save: _vm.saveObject,
      close: _vm.closeForm
    },
    scopedSlots: _vm._u([
      {
        key: "formFields",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleTabs[_vm.activeTab].type === "form",
                    expression: "visibleTabs[activeTab].type === 'form'"
                  }
                ],
                staticClass: "form tab-content"
              },
              _vm._l(_vm.visibleTabs[_vm.activeTab].fields, function(field) {
                return _c("input-field", {
                  key:
                    _vm.visibleTabs[_vm.activeTab].code +
                    field.label +
                    field.order,
                  ref: "formInputField",
                  refInFor: true,
                  attrs: {
                    value: _vm.getValueInObject(
                      field.var_name,
                      field.input_type
                    ),
                    label: field.label_client
                      ? field.label_client
                      : field.label,
                    "variable-name": field.var_name,
                    inputType: field.input_type,
                    size: field.size,
                    required: field.required,
                    "required-filled": _vm.required.filled,
                    selectOptions: field.select_list_name,
                    radioOptions: field.radio_options,
                    fieldDisabled: field.disable,
                    tabDisabled: !_vm.userCanEditTabContent(
                      _vm.visibleTabs[_vm.activeTab]
                    ),
                    formDisabled: _vm.readOnly,
                    hide: field.hide,
                    checkboxOptions: field.checkbox_options,
                    "object-data": _vm.objectData,
                    labelIsLocked: _vm.objectData.anp_label_locked,
                    "user-can-unlock-label": !_vm.userHasFibercloudPermission(
                      _vm.form.permission + "_manage_label"
                    )
                  },
                  on: {
                    input: function($event) {
                      return _vm.setValueInObject(
                        field.var_name,
                        $event,
                        field.input_type
                      )
                    },
                    "toggle-label-lock": _vm.changeLabelMode,
                    updateCheckboxValue: function($event) {
                      return _vm.updateCheckboxValue($event)
                    },
                    removePhoto: function($event) {
                      return _vm.addToPhotosToRemove($event)
                    }
                  }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleTabs[_vm.activeTab].type === "photos",
                    expression: "visibleTabs[activeTab].type === 'photos'"
                  }
                ],
                staticClass: "form tab-content"
              },
              [
                _c("forms-photo-section", {
                  attrs: {
                    disabled: _vm.readOnly,
                    imagesList: _vm.imagesList,
                    "previous-images": _vm.previousImages
                  },
                  on: {
                    updatePhoto: function($event) {
                      return _vm.updatePhoto($event)
                    },
                    removePhoto: function($event) {
                      return _vm.addToPhotosToRemove($event)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.visibleTabs[_vm.activeTab].code === "custom_fields"
              ? _c("custom-fields-tab", {
                  attrs: {
                    customFields: _vm.customFields.custom_fields,
                    objectData: _vm.objectData.custom_fields,
                    actionType: _vm.actionType,
                    disabled: _vm.readOnly,
                    requiredFilled: _vm.required.filled
                  },
                  on: { updateValue: _vm.setValueInObject }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53795366", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53795366","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/ObjectForms/AnnotationPointForm.vue
// module id = null
// module chunks = 